export const CONTACTS_PER_SALE = 4 * 34 * 40;

export function getIdealNumberOfSalesByResult(totalResult) {
  return Math.ceil(totalResult / CONTACTS_PER_SALE);
}

export function getTargetingContactsTotal(onBoarding) {
  if (onBoarding.order_type === "activation") {
    return onBoarding.activationContactsCount || 0;
  }
  if (onBoarding.apollo && onBoarding.apollo.total_result > 0) {
    return onBoarding.apollo.total_result;
  }
  if (onBoarding.total_contacts && onBoarding.total_contacts > 0) {
    return onBoarding.total_contacts;
  }
  return 0;
}

export function getCurrentSalesQuantity(onBoarding, salesCount = null) {
  if (salesCount !== null && salesCount !== undefined) {
    return salesCount;
  }
  if (onBoarding.step3 && onBoarding.step3.teamMembers) {
    return onBoarding.step3.teamMembers.length;
  }
  return 0;
}

export function isValidSalesQuantity(onBoarding, salesCount = null, pendingAdd = 0) {
  const totalResult = getTargetingContactsTotal(onBoarding);
  const quantity = getCurrentSalesQuantity(onBoarding, salesCount) + pendingAdd;

  return (
    totalResult > 0 &&
    getIdealNumberOfSalesByResult(totalResult) >= quantity
  );
}

export function getSalesQuantityBlockReason(onBoarding, salesCount = null, pendingAdd = 0) {
  const totalResult = getTargetingContactsTotal(onBoarding);

  if (totalResult <= 0) {
    return "no_contacts";
  }

  if (!isValidSalesQuantity(onBoarding, salesCount, pendingAdd)) {
    return "over_limit";
  }

  return null;
}
